import dayjs from 'dayjs';

export const pushDraftCacheKey = (endpoint, environment, owner, id) => owner
    ? `push-campaign-draft:v1:${JSON.stringify([endpoint || '', environment || '', String(owner), id || 'new'])}`
    : null;

// Cache only the form and its revision, never recipient/device tokens or send requests.
const formCampaign = (campaign) => Object.fromEntries([
    'id', 'name', 'businessType', 'targetParams', 'platforms', 'contents', 'revision',
    'sourceRevision', 'status', 'sendMode', 'scheduledAt', 'timezone', 'ttlHours', 'imageUrl', 'customData', 'customDataRows', 'protectedTitleTickers', 'protectedBodyTickers', 'protectedTitleKeywords', 'protectedBodyKeywords',
].map((key) => [key, campaign[key]]));

export function readPushDraft(key) {
    if (!key) return null;
    try {
        const draft = JSON.parse(window.localStorage.getItem(key));
        const c = draft?.campaign;
        if (draft?.version !== 1 || !c || typeof c.id !== 'string' || typeof c.name !== 'string'
            || (c.customData !== undefined && c.customData !== null && (typeof c.customData !== 'object' || Array.isArray(c.customData) || (c.customData.values !== undefined && (typeof c.customData.values !== 'object' || c.customData.values === null || Array.isArray(c.customData.values) || !Object.values(c.customData.values).every((v) => typeof v === 'string')))))
            || (c.customDataRows !== undefined && (!Array.isArray(c.customDataRows) || !c.customDataRows.every((v) => v && typeof v.key === 'string' && typeof v.value === 'string')))
            || ['protectedTitleTickers', 'protectedBodyTickers', 'protectedTitleKeywords', 'protectedBodyKeywords'].some((key) => c[key] !== undefined && (!Array.isArray(c[key]) || !c[key].every((v) => typeof v === 'string')))
            || (c.imageUrl !== undefined && typeof c.imageUrl !== 'string')
            || typeof c.businessType !== 'string' || !c.targetParams || typeof c.targetParams !== 'object'
            || !Array.isArray(c.platforms) || !c.platforms.every((p) => typeof p === 'string')
            || !Array.isArray(c.contents) || !c.contents.every((v) => v && typeof v.locale === 'string' && typeof v.title === 'string' && typeof v.body === 'string')
            || !Number.isInteger(c.revision) || !Number.isInteger(c.sourceRevision)
            || !Number.isFinite(c.ttlHours) || typeof c.status !== 'string'
            || typeof draft.dirty !== 'boolean' || typeof draft.locale !== 'string'
            || !['immediate', 'scheduled'].includes(draft.scheduleMode) || typeof draft.zone !== 'string'
            || (draft.scheduleLocal !== null && (typeof draft.scheduleLocal !== 'string' || !dayjs(draft.scheduleLocal).isValid()))) return null;
        new Intl.DateTimeFormat('en', { timeZone: draft.zone });
        return { ...draft, campaign: formCampaign(c) };
    } catch {
        return null;
    }
}

export function writePushDraft(key, snapshot) {
    if (!key) return true;
    try {
        window.localStorage.setItem(key, JSON.stringify({
            version: 1, ...snapshot, campaign: formCampaign(snapshot.campaign),
        }));
        return true;
    } catch {
        return false;
    }
}

export function removePushDraft(key) {
    if (!key) return true;
    try {
        window.localStorage.removeItem(key);
        return true;
    } catch {
        return false;
    }
}
